import jsPDF from 'jspdf';
import scLogoSrc from '../../Assets/SC_logo.png';

const COMPANY = {
  name: 'Square Computers',
  address: 'KV HOLLA BUILDING, KARANTH STREET, Saligrama',
  phone: '9164915365',
  email: 'squaresaligrama@gmail.com',
  signedBy: 'Sharath Kumar',
  website: 'https://squarecomputers.in',
};

// Where /verify/{number} lives — used for the "Click here to verify" link.
const VERIFY_BASE = 'https://squarecomputers.in/verify';

const TERMS = [
  'Payment : 100% Advance',
  'Delivery Within 3 Working Days after receiving the Purchase Order.',
  'Quotation validity 1 week',
];

const BANK = [
  ['Account Holder', 'SHARATH KUMAR M'],
  ['Account Number', '50200104257071'],
  ['IFSC', 'HDFC0006721'],
  ['Branch', 'KOTA UDUPI'],
  ['Account Type', 'Current Account'],
];

const C = {
  serial: { center: 18 },
  name:   { left: 24, maxW: 86 },
  qty:    { center: 126 },
  price:  { right: 169 },
  amount: { right: 196 },
};

const PAD_TOP = 5;
const PAD_BOT = 3;
const PAGE_MARGIN_BOT = 26;

function fmtAmt(n) {
  return 'Rs. ' + Number(n).toLocaleString('en-IN');
}

async function toGrayscaleBase64(src) {
  return new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = imageData.data;
      for (let i = 0; i < d.length; i += 4) {
        const gray = Math.round(0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]);
        d[i] = d[i + 1] = d[i + 2] = gray;
      }
      ctx.putImageData(imageData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

function drawTableHeader(doc, y, pageW) {
  doc.setFillColor(240, 240, 240);
  doc.rect(14, y, pageW - 28, 8, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  const hY = y + 5.5;
  doc.text('#',          C.serial.center, hY, { align: 'center' });
  doc.text('Item name',  C.name.left,     hY);
  doc.text('Qty',        C.qty.center,    hY, { align: 'center' });
  doc.text('Price/unit', C.price.right,   hY, { align: 'right' });
  doc.text('Amount',     C.amount.right,  hY, { align: 'right' });
  y += 8;
  doc.setLineWidth(0.3);
  doc.line(14, y, pageW - 14, y);
  return y + PAD_TOP;
}

export async function buildQuotePDF(
  quoteNumber, customerName, phoneNumber, date, items, total,
  address = ''
) {
  const logoBase64 = await toGrayscaleBase64(scLogoSrc);
  // compress: true → lossless Flate compression of the PDF streams (smaller
  // file, identical quality).
  const doc = new jsPDF({ compress: true });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  let y = 12;

  if (logoBase64) {
    const props = doc.getImageProperties(logoBase64);
    const maxW = 112, maxH = 60;
    const scale = Math.min(maxW / props.width, maxH / props.height);
    doc.addImage(logoBase64, 'PNG', pageW - 14 - props.width * scale, -8, props.width * scale, props.height * scale);
  }

  // Company header
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text(COMPANY.name, 14, y);
  y += 7;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(50, 50, 50);
  doc.text(COMPANY.address, 14, y); y += 5;
  doc.text('Phone: ' + COMPANY.phone, 14, y); y += 5;
  doc.setFont('helvetica', 'normal');
  doc.text('Email: ' + COMPANY.email, 14, y);
  y += 8;
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.4);
  doc.line(14, y, pageW - 14, y);
  y += 10;

  // Title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(0, 0, 0);
  doc.text('Quotation', pageW / 2, y, { align: 'center' });
  y += 14;

  // Quote To / Quotation Details
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Quote To', 14, y);
  doc.text('Quotation Details', pageW - 14, y, { align: 'right' });
  y += 7;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Quote No.: ' + quoteNumber, pageW - 14, y,     { align: 'right' });
  doc.text('Date: ' + date,             pageW - 14, y + 5, { align: 'right' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const nameLines = doc.splitTextToSize(customerName, 88);
  nameLines.forEach((line, i) => doc.text(line, 14, y + i * 5));
  let leftY = y + nameLines.length * 5;
  doc.text(phoneNumber, 14, leftY);
  leftY += 5;
  if (address && address.trim()) {
    const addrLines = doc.splitTextToSize(address.trim(), 88);
    addrLines.forEach((ln, i) => doc.text(ln, 14, leftY + i * 5));
    leftY += addrLines.length * 5;
  }
  y = leftY + 8;

  // Table
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.4);
  doc.line(14, y, pageW - 14, y);
  y += 1;
  y = drawTableHeader(doc, y, pageW);

  doc.setFontSize(9);
  items.forEach((item, i) => {
    const nameW = doc.splitTextToSize(item.itemName || '', C.name.maxW);
    // Warranty shown as a small line right under the product name (no separate
    // "Warranty Details" section in quotations).
    const warrantyText = (item.warranty && item.warranty !== 'No') ? `${item.warranty} warranty` : '';
    const hasWarranty = !!warrantyText;
    const WARRANTY_GAP = 4;
    const rowH = nameW.length * 5 + (hasWarranty ? WARRANTY_GAP : 0) + PAD_TOP + PAD_BOT;

    if (y + rowH > pageH - PAGE_MARGIN_BOT) {
      doc.addPage();
      y = 14;
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.4);
      doc.line(14, y, pageW - 14, y);
      y += 1;
      y = drawTableHeader(doc, y, pageW);
    }

    const textTop = y;
    const midY = textTop + (nameW.length - 1) * 5 / 2;

    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(String(i + 1), C.serial.center, midY, { align: 'center' });

    doc.setFont('helvetica', 'bold');
    nameW.forEach((ln, li) => doc.text(ln, C.name.left, textTop + li * 5));

    if (hasWarranty) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(90, 90, 90);
      doc.text(warrantyText, C.name.left, textTop + (nameW.length - 1) * 5 + WARRANTY_GAP);
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
    }

    doc.setFont('helvetica', 'normal');
    doc.text(String(item.quantity),                              C.qty.center,   midY, { align: 'center' });
    doc.text(fmtAmt(item.price),                                 C.price.right,  midY, { align: 'right' });
    doc.text(fmtAmt(Number(item.quantity) * Number(item.price)), C.amount.right, midY, { align: 'right' });

    y += nameW.length * 5 + (hasWarranty ? WARRANTY_GAP : 0) + PAD_BOT;

    if (i < items.length - 1) {
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.2);
      doc.line(14, y, pageW - 14, y);
      doc.setDrawColor(0, 0, 0);
      y += PAD_TOP;
    }
  });

  y += 2;
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.4);
  doc.line(14, y, pageW - 14, y);
  y += 8;

  // Total
  if (y + 16 > pageH - PAGE_MARGIN_BOT) { doc.addPage(); y = 20; }
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('Total', C.price.right, y, { align: 'right' });
  doc.text(fmtAmt(total), C.amount.right, y, { align: 'right' });
  y += 16;

  // ── Terms and Conditions ────────────────────────────────────────────────
  if (y + 30 > pageH - PAGE_MARGIN_BOT) { doc.addPage(); y = 20; }
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('Terms and Conditions', 14, y);
  y += 8;
  doc.setFontSize(9.5);
  TERMS.forEach((line, i) => {
    if (y + 7 > pageH - PAGE_MARGIN_BOT) { doc.addPage(); y = 20; }
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(30, 30, 30);
    const label = `${i + 1}. `;
    doc.text(label, 18, y);
    const labelW = doc.getTextWidth(label);
    const wrapped = doc.splitTextToSize(line, pageW - 28 - labelW);
    wrapped.forEach((ln, li) => doc.text(ln, 18 + labelW, y + li * 5));
    y += wrapped.length * 5 + 2;
  });
  y += 6;

  // ── Bank Details (HDFC) ─────────────────────────────────────────────────
  if (y + 12 + BANK.length * 5.5 > pageH - PAGE_MARGIN_BOT) { doc.addPage(); y = 20; }
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('Bank Details', 14, y);
  y += 8;
  doc.setFontSize(9.5);
  BANK.forEach(([label, value]) => {
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(60, 60, 60);
    const l = `${label}: `;
    doc.text(l, 18, y);
    const lw = doc.getTextWidth(l);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(String(value), 18 + lw, y);
    y += 5.8;
  });

  // ── Verify line + footer (site visit link + digital signature) ──────────
  const lastPageH = doc.internal.pageSize.getHeight();
  const footerY = lastPageH - 16;

  // Genuine-quotation verify line (left) — replaces the old "visit website"
  // link since both pointed to the same site.
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(90, 90, 90);
  const vPre = 'This is a genuine quotation. ';
  doc.text(vPre, 14, footerY);
  const vPreW = doc.getTextWidth(vPre);
  doc.setTextColor(37, 99, 235);
  doc.textWithLink('Click here to verify', 14 + vPreW, footerY, { url: `${VERIFY_BASE}/${quoteNumber}` });
  const vLinkW = doc.getTextWidth('Click here to verify');
  doc.setLineWidth(0.2);
  doc.setDrawColor(37, 99, 235);
  doc.line(14 + vPreW, footerY + 0.8, 14 + vPreW + vLinkW, footerY + 0.8);

  // Digital signature (right)
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text('Digitally signed by: ' + COMPANY.signedBy, pageW - 14, footerY, { align: 'right' });

  return doc.output('blob');
}
